<template>
  <v-dialog scrollable fullscreen v-model="config.status.active">
    <v-card class="dialog client apply publish">
      <v-card-title class="grey lighten-3">
        <span>申し込み内容補足情報シート</span>
      </v-card-title>
      <v-card-text class="pa-0">
        <PDFMaker ref="viewer" @done="close" @error="fail" />
      </v-card-text>
      <v-card-actions>
        <v-btn text
          color="secondary"
          :disabled="isLoading"
          @click="update">更新する</v-btn>
        <v-spacer></v-spacer>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-btn depressed
          color="secondary"
          :loading="isLoading"
          @click="publish">発行する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PDFMaker from './pdfmaker'
export default {
  name: 'clientAboutModalsPublish',
  components: {
    PDFMaker
  },
  data () {
    return {
      config: {
        status: {
          loading: false,
          active: false
        }
      }
    }
  },
  methods: {
    open: function () {
      this.$set(this.config.status, 'active', true)
      this.$nextTick(() => {
        this.update()
      })
    },
    close: function () {
      this.$set(this.config.status, 'loading', false)
      this.$set(this.config.status, 'active', false)
      this.$emit('close')
    },
    update: function () {
      if (this.$refs.viewer) {
        this.$refs.viewer.update()
      }
    },
    publish: function () {
      if (this.$refs.viewer) {
        this.$refs.viewer.publish()
        this.$set(this.config.status, 'loading', true)
      }
    },
    fail: function () {
      this.$set(this.config.status, 'loading', false)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    }
  }
}
</script>